import { captureException } from "@sentry/nextjs";

import type { ValidatorResponse } from "types/validator-info";
import { DEFAULT_ENDPOINT } from "utils/web3/endpoints";

export enum ValidatorsSortingBy {
  Stake = "Stake",
  Credits = "Credits",
  MarinadeScore = "MarinadeScore",
  Apy = "Apy",
  Commission = "Commission",
  Uptime = "Uptime",
}

export async function fetchAllValidators(
  limit: number,
  searchTerm?: string,
  epochs?: number,
  ids?: string[],
  onlyWithMarinadeStake?: boolean,
  from_datetime?: string,
  sortBy?: ValidatorsSortingBy
): Promise<ValidatorResponse | undefined> {
  try {
    const params = new URLSearchParams({ limit: limit.toString() });

    if (searchTerm) {
      params.append("query", searchTerm);
    }
    if (typeof epochs === "number") {
      params.append("epochs", epochs.toFixed(0));
    }
    if (ids) {
      params.append("query_vote_accounts", ids.toString());
    }
    if (onlyWithMarinadeStake) {
      params.append("query_marinade_stake", "true");
    }
    if (from_datetime) {
      params.append("query_from_date", from_datetime);
    }
    if (sortBy) {
      params.append("order_field", sortBy);
    }

    const response = await fetch(
      `${DEFAULT_ENDPOINT.dsEndpoint}validators?${params.toString()}`
    );

    if (!response.ok) {
      throw new Error(`${response.statusText} /// ${response.status}`);
    }

    return (await response.json()) as ValidatorResponse;
  } catch (err) {
    captureException(err);
    return undefined;
  }
}
